import { Component } from '@angular/core';
import { TitleCardModel } from '../../../../models/title-card.model';

@Component({
  selector: 'app-lecturers',
  templateUrl: './lecturers.component.html',
  styleUrl: './lecturers.component.scss',
  standalone: false,
})
export class LecturersComponent {
  public titleCard: TitleCardModel = {
    image: '../../../assets/images/placeholder.svg',
  };
}
